export const getCommaSeparatedText = (list: { name?: string }[] = []) => {
  if (list.length === 0) return '-'

  return list.map(item => item?.name).join(', ')
}
